var $ = jQuery;

$(document).foundation();

var $html = $('html');
var $body = $('body');
var $window = $(window);
var $header = $('header');
var $main = $('main');
var $footer = $('footer');

function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;
  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
}

function adjustAspectRatios() {
  // must have this for backward compatibility
  // ugh
  // 1 / 1
  $('.rounded-image, .block-references.layout-tile-large .research-container').each(function() {
    var $current = $(this);
    $current.height($current.width());
  });
  // articles, 424/300
  $('.block-articles .article-container .image-container, .single-post main .hero-image, .single-blog-entry main .hero-image').each(function() {
    var $current = $(this);
    $current.height(300 / 424 * $current.width());
  });
  // caregivers, 400/468
  $('.block-caregivers .layout-grid .caregiver-image').each(function() {
    var $current = $(this);
    $current.height($current.width());
  })
  // tiled images, 360 / 500
  $('.block-tiled-images .image-tile').each(function() {
    var $current = $(this);
    $current.height(500 / 360 * $current.width());
  });
  // special, only for large
  if (Foundation.MediaQuery.is('large')) {
    // hover animation for submenu
    $('.mobile-submenu .menu-item').each(function() {
      var $current = $(this);
      $current.height($current.width());  
    });
  }
}

$(document).ready(function() {

	// Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    $(this).parent().addClass('responsive-embed widescreen')
  })

  adjustAspectRatios();

  handlerNavigation.init();
  handlerBlocks.init();

  // debugger
  $window.on('resize', function() {
    // adjust for that pesky bottom navbar on mobile browsers
    handlerNavigation.adjustFirstSectionPadding();
    adjustAspectRatios();
    $('body').css('--window-height',window.innerHeight+'px');
    $('body').css('--header-height',$header.outerHeight()+'px');
    $('.debugger .column-width').html($('.debugger .cell').eq(0).width())
    $('.debugger .gutter-width').html(parseInt($('.debugger .cell').eq(0).css('margin-left')) * 2)
    $('.debugger .container-padding').html(parseInt($('.debugger .grid-container').eq(0).css('padding-left')) * 2)
  }).trigger('resize');

  $('body').css('--initial-window-height',window.innerHeight+'px');

  $('.debugger').on('click', function(e) {
    $(this).remove()
  });

  // autplay video on reveal
  $('.reveal.video-reveal')
    .on('open.zf.reveal', function() {
      $(this).find('video').get(0).play();
    })
    .on('closed.zf.reveal', function() {
      $(this).find('video').get(0).pause();
    });

  // those pesky empty paragraph!
  $('p').each(function() {
    if ($(this).is(':empty')) $(this).remove();
  });
  if (Foundation.MediaQuery.is('large')) {
    var headroom  = new Headroom(document.querySelector("header"));
    headroom.init();  
  }

  if(window.location.hash) {
    var $hashTarget = $(window.location.hash);
    if ($hashTarget.is('section')) {
      handlerNavigation.scrollIntoView($hashTarget);
    }
  }

})
